export enum PaymentType {
    creditCard = 'Credit card',
    paypal = 'paypal',
}
